import { ChangeDetectorRef, Component, ElementRef, Inject, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Subscription } from "rxjs";
import { SliderItemModel } from "src/core/categories/categories.models";
import { CategoriesSandbox } from "src/core/categories/categories.sandbox";
import { MessageService } from "src/core/services/messages.service";
import { environment } from "src/environments/environment";
import { PromtDialogComponent } from "../promt-dialog/promt.dialog";

@Component({
    templateUrl: './slider-item.dialog.html',
    styleUrls: ['./slider-item.dialog.scss']
})
export class SliderItemDialogComponent implements OnInit, OnDestroy {
    @ViewChild('fileInput') fileInput: ElementRef;
    private subs: Subscription[] = [];

    sliderForm: FormGroup;
    title: FormControl = new FormControl('', Validators.required);
    subtitle: FormControl = new FormControl('');
    description: FormControl = new FormControl('');
    typeitem: FormControl = new FormControl('image');
    position: FormControl = new FormControl(0);
    content: FormControl = new FormControl('');

    file: File;
    fileURL: string;
    fileName: string;

    sliderList: SliderItemModel[] = [];
    public IMAGES_URL = environment.IMAGES_URL;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: SliderItemModel | any,
        private message: MessageService,
        private cd: ChangeDetectorRef,
        private dialogRef: MatDialogRef<SliderItemDialogComponent>,
        private dialog: MatDialog,
        private fb: FormBuilder,
        public categoriesSandbox: CategoriesSandbox
    ) {
        this.categoriesSandbox.doClearCreateSliderItemState();
        this.categoriesSandbox.doClearUpdateSliderItemState();
        this.categoriesSandbox.doClearRemoveSliderItemState();
        this.categoriesSandbox.doClearGetSliderItemState();

        // console.log(this.data);
    }

    ngOnInit(): void {
        this.sliderForm = this.fb.group({
            typeitem: this.typeitem,
            description: this.description,
            title: this.title,
            subtitle: this.subtitle,
            content: this.content,
            position: this.position
        })

        this.typeitem.disable();
        this.pathEditedData();

        this.subs.push(this.categoriesSandbox.createSliderItemData$.subscribe(res => {
            if (res) {
                console.log(res);
                this.message.log('Slider created!');
                this.dialogRef.close(res);
            }
        }))
        this.subs.push(this.categoriesSandbox.createSliderItemFailData$.subscribe(res => {
            if (res) {
                this.message.log('Server error!');
            }
        }));
        this.subs.push(this.categoriesSandbox.getSliderListData$.subscribe((res: SliderItemModel[]) => {
            if (res) {
                // console.log(res);
                if (this.data && this.data.sliderType) {
                    this.sliderList = res.filter(el => el.typeitem === this.data.sliderType);
                } else {
                    this.sliderList = res || [];
                }
            }
        }))
        this.subs.push(this.categoriesSandbox.getSliderListFailData$.subscribe(res => {
            if (res) {
                this.message.log('Server error!');
            }
        }))

        this.subs.push(this.categoriesSandbox.removeSliderItemData$.subscribe(res => {
            if (res) {
                this.message.log('Item removed!');
                this.getSliderItems();
            }
        }))
        this.subs.push(this.categoriesSandbox.removeSliderItemFailData$.subscribe(res => {
            if (res) {
                this.message.log('Server error!');
            }
        }))

        this.subs.push(this.categoriesSandbox.updateSliderItemData$.subscribe(res => {
            if (res) {
                this.message.log('Item updated!');
                this.dialogRef.close(res);
                // this.getSliderItems();
            }
        }))
        this.subs.push(this.categoriesSandbox.updateSliderItemFailData$.subscribe(res => {
            if (res) {
                this.message.log('Server error!');
            }
        }))
    }

    private pathEditedData(): void {
        if (this.data && this.data.id) {
            this.typeitem.patchValue(this.data.typeitem);
            this.description.patchValue(this.data.description);
            this.title.patchValue(this.data.title);
            this.subtitle.patchValue(this.data.subtitle);
            this.content.patchValue(this.data.content);
            this.position.patchValue(this.data.position);
        }

        if (this.data && this.data.sliderType) {
            this.typeitem.patchValue(this.data.sliderType);
            this.typeitem.disable();
        }
    }

    addItem(): void {
        if (this.sliderForm.invalid) {
            this.message.log('Form invalid!');
            return;
        }

        const params: FormData = new FormData();
        params.append('typeitem', this.typeitem.value);
        params.append('description', this.description.value);
        params.append('title', this.title.value);
        params.append('subtitle', this.subtitle.value);
        params.append('content', this.content.value);
        params.append('position', this.position.value);

        if (this.file && this.file.name) {
            params.append('image', this.file, this.file.name);
        }

        if (this.data && this.data.id) {
            params.append('id', '' + this.data.id);
            this.categoriesSandbox.doUpdateSliderItem(params);
        } else {
            this.categoriesSandbox.doCreateSliderItem(params);
        }
    }

    onFileChanged(event: any): void {
        const URL = window.URL || window.webkitURL;
        const Img = new Image();

        const f: File = event.target.files[0] as File;
        this.file = f;
        Img.src = URL.createObjectURL(f);

        Img.onload = (e: any) => {
            const ratio = 340 / 226;

            const height = e.path[0].height;
            const width = e.path[0].width;

            if (width / height === ratio) {
                const reader = new FileReader();
                reader.readAsDataURL(this.file);
                reader.onload = (e: any) => {
                    // this.editedImage = null;
                    this.fileURL = reader.result.toString();
                    console.log('success')
                }
            } else {
                this.message.log('Image ratio must be 340:226')
                this.file = null;
                this.fileInput.nativeElement.value = '';
            }
        }

        // if (f && f.size < 31457280) {
        //     this.file = f;
        //     const reader = new FileReader();
        //     reader.readAsDataURL(this.file);
        //     reader.onload = (e) => {
        //         this.fileURL = reader.result.toString();
        //     };
        // } else {
        //     this.message.log('File size must be lowerest than 30 mb');
        // }
    }

    private getSliderItems(): void {
        this.categoriesSandbox.doGetSliderList({});
    }

    selectItem(item: SliderItemModel): void {
        if (item && item.id) {
            this.dialogRef.close(item);
        }
    }

    removeItem(item: SliderItemModel): void {
        if (item && item.id) {
            this.dialog.open(PromtDialogComponent).afterClosed().subscribe(res => {
                if (res) {
                    this.categoriesSandbox.doRemoveSliderItem(item.id);
                }
            })
        }
    }

    changeTab(index: number): void {
        if (index === 1) {
            this.getSliderItems();
        }
    }

    ngOnDestroy(): void {
        this.subs.map(s => s.unsubscribe());
    }
}